export default __webpack_public_path__ + "873c049f0f2586f07a40dbdfdeef4a1a.png";